// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bdaf28bf","453":"a9fb8caa","732":"4395cf7c","977":"e81ec6f6"}[chunkId] + ".chunk.js";
};